export default __webpack_public_path__ + "8f96bce5372bc2ffc074841d462e80b0.png";